(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"]) return;
  try {
    
  document.body.setAttribute('data-theme', 'dark');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-hero-logo-root]');

    roots.forEach((root) => {
      if (root.dataset.heroLogoInitialized === 'true') {
        return;
      }
      root.dataset.heroLogoInitialized = 'true';

      const variantCount = 5;
      const letters = ['1', '2', '3'];
      // Default: 13 + 21 + 31 (variant index 0-based per letter)
      const letterState = { 1: 2, 2: 0, 3: 0 };

      const setVariant = (letter, nextIndex) => {
        const letterNode = root.querySelector(`[data-letter="${letter}"]`);
        if (!letterNode) {
          return;
        }

        const variants = letterNode.querySelectorAll('[data-variant]');
        variants.forEach((variantNode, variantIndex) => {
          variantNode.classList.toggle('is-active', variantIndex === nextIndex);
        });
      };

      const cycleLetter = (letter) => {
        const current = letterState[letter] || 0;
        const next = (current + 1) % variantCount;
        letterState[letter] = next;
        setVariant(letter, next);
      };

      const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (hoverCapable) {
        const columns = root.querySelectorAll('[data-column]');
        columns.forEach((columnNode) => {
          columnNode.addEventListener('mouseenter', () => {
            const letter = columnNode.getAttribute('data-column');
            if (!letter) {
              return;
            }
            cycleLetter(letter);
          });
        });
        return;
      }

      let mobileTimer = null;
      const minDelay = 200;
      const maxDelay = 1500;

      const scheduleNext = () => {
        const delay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
        mobileTimer = window.setTimeout(() => {
          const randomLetter = letters[Math.floor(Math.random() * letters.length)];
          cycleLetter(randomLetter);
          scheduleNext();
        }, delay);
      };

      scheduleNext();

      document.addEventListener('shopify:section:unload', () => {
        if (mobileTimer) {
          window.clearTimeout(mobileTimer);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
